export default {
  comments: [],
  reviews: [],
  count: 0
};
